/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as services from 'services';
import { includeType, includeActiveChild } from 'helpers';
import { useCreateDispatches } from 'helpers/hooks';
import { getLifebooksChild } from 'redux/selectors';
import {
	getRequestedPostFeedType,
	isServicePostState,
	resolveNspId,
} from '../../EditPost/utils/servicePostUtils';
import useEditPostState from './useEditPostState';

export default function useFetchPost() {
	const { state, setState, setDefaultState, handlers } = useEditPostState();
	const {
		location: { search, state: locationState },
	} = useHistory();

	const { setFeedType, setLoader } = useCreateDispatches();

	const { postId } = useParams();
	const child = useSelector(getLifebooksChild);

	const { approved } = state;

	useEffect(() => {
		// redirect away if:
		// - post is already approvewd
		// -
		if (
			(!approved && includeType(['child', 'contributor'])) ||
			includeType(['agencyuser', 'contributor', 'csw']) ||
			(includeType(['child']) && includeActiveChild())
		) {
		}
	}, []);

	useEffect(() => {
		const requestedFeedType = getRequestedPostFeedType(search, locationState);
		const setPostState = (post) => {
			const normalizedPost = {
				...post,
				category: post.category?.id || post.category,
				nspId: resolveNspId(post),
				nspDescription:
					post.nspDescription || post.nsp?.description || null,
				servicesCategory:
					post.servicesCategory || post.nsp?.servicesCategory || null,
			};
			setState(normalizedPost);
			if (isServicePostState(normalizedPost)) {
				setFeedType('services');
			} else if (requestedFeedType) {
				setFeedType(requestedFeedType);
			}
		};

		const fetchPost = async () => {
			setLoader(true);
			const getPost = postId?.startsWith?.('dft_')
				? services.getDraft
				: services.getPost;
			await getPost(postId)
				.then(setPostState)
				.finally(() => {
					setLoader(false);
				});
		};

		if (locationState && (locationState.id || locationState.postDraftId)) {
			setPostState(locationState);
		} else if (postId) {
			fetchPost();
		} else {
			setDefaultState();
			setFeedType(requestedFeedType || 'timeline');
		}
	}, [postId, child, child.id, search]);

	return { state, setState, setDefaultState, handlers };
}
